import { render, staticRenderFns } from "./footerMobile.vue?vue&type=template&id=54cbe014&scoped=true&"
import script from "./footerMobile.vue?vue&type=script&lang=js&"
export * from "./footerMobile.vue?vue&type=script&lang=js&"
import style0 from "./footerMobile.vue?vue&type=style&index=0&id=54cbe014&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cbe014",
  null
  
)

/* custom blocks */
import block0 from "./footerMobile.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports